//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false, moment: false */

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('fancyRadioButton', () => {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        id: '@',
        name: '@',
        ngDisabled: '=',
        ngModel: '=',
        ngValue: '=',
        defaultColor: '=',
        ngChange: '&',
      },
      template: '<div class="fancy-radio-button">' +
                          '<input ng-disabled="ngDisabled" type="radio" ng-model="ngModel"' +
                                 'ng-attr-id="label-{{id}}" ng-value="ngValue" ng-attr-name="{{name}}" ng-change="triggerChanged()" />' +
                          '<label ng-attr-for="label-{{id}}">' +
                              '<span class="outer-circle" ng-class="{ \'defaultColor\': defaultColor }">' +
                                  '<div class="circle" ng-show="ngModel === ngValue"></div>' +
                              '</span>' +
                              '<div ng-transclude></div>' +
                          '</label>' +
                      '</div>',
      controller: ['$scope', function($scope) {
        $scope.triggerChanged = function() {
          $scope.ngChange();
        };
      }],
    };
  });
})();
